import React from "react";
import MontageGif from "../Images/image1.gif";

function Montage() {
    return <div className="montage-container">
                <img loading="lazy" src={MontageGif} alt="flashing goldoxe works" />
                {/* <Link to="/Slaps">
                <img className="slaps-button" src={SlapsLogo} alt="Slaps Logo" />
                </Link> */}
            </div>
}

export default Montage;